import { Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

import ProfileSection from './profile/index';
import AppBreadcrumb from 'components/breadcrumb';
import { BRAND } from 'themes';

type HeaderProps = {
    sidebarOpen: boolean;
    onToggleSidebar: () => void;
};

function Header({ sidebarOpen, onToggleSidebar }: HeaderProps) {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                color: 'text.secondary',
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1 }}>
                <IconButton
                    onClick={onToggleSidebar}
                    aria-label={sidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
                    sx={{
                        display: {
                            xs: 'inline-flex',
                            md: sidebarOpen ? 'none' : 'inline-flex',
                        },
                        width: 36,
                        height: 36,
                        borderRadius: '12px',
                        border: `1px solid ${BRAND.border}`,
                        bgcolor: '#fff',
                        color: BRAND.ink,
                        boxShadow: '0 8px 16px -12px rgba(27, 19, 64, 0.45)',
                        cursor: 'pointer',
                        transition: 'background-color 200ms ease, border-color 200ms ease',
                        '&:hover': {
                            bgcolor: BRAND.track,
                            borderColor: '#DDD8EE',
                        },
                        '&.Mui-focusVisible': {
                            outline: `2px solid ${BRAND.primary}`,
                            outlineOffset: 2,
                        },
                    }}>
                    {sidebarOpen ? <MenuOpenIcon fontSize='small' /> : <MenuIcon fontSize='small' />}
                </IconButton>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <AppBreadcrumb />
                </Box>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                <ProfileSection />
            </Box>
        </Box>
    );
}

export default Header;
